import { useSelector } from "react-redux";

export const BotIcon = (props: { type: 'agent' | 'bot' }) => {
	const design = useSelector((state: any) => state?.design);
	const environment = useSelector((state: any) => state?.environment);

	return (
		design.avatarPlacement === 'top'
			?
			<div className="flex">
				<img className={`ele-bot-icon avatar border-secondaryBgColor ${design.avatarOutlineOffMessage ? '' : 'border-2'} mt-2 ${environment?.direction === 'ltr' ? 'mr-2' : 'ml-2'}`} alt=""
					style={{
						width: (25 * (design.avatarIconSizeMessageBubble || 1)) + 'px',
						height: (25 * (design.avatarIconSizeMessageBubble || 1)) + 'px',
						borderRadius: '50%'
					}} src={props.type === 'agent' ? (environment.agentAvatar || design.avatar) : design.avatar} />
				{design.avatarPlacement === 'top' &&
					<p className="ele-text-bot-name mt-auto text-xs"  style={{ color: '#333333' }}>{(props.type === 'agent' && environment.agentName) ? environment.agentName : design.name}</p>
				}
			</div>
			: <img className={`ele-bot-icon avatar border-secondaryBgColor ${design.avatarOutlineOffMessage ? '' : 'border-2'} mt-2 ${environment?.direction === 'ltr' ? 'mr-2' : 'ml-2'}`} alt=""
				style={{
					width: (42 * (design.avatarIconSizeMessageBubble || 1)) + 'px',
					height: (42 * (design.avatarIconSizeMessageBubble || 1)) + 'px',
					borderRadius: '50%'
				}} src={props.type === 'agent' ? (environment.agentAvatar || design.avatar) : design.avatar} />
	);
}